import { clsx } from "clsx";
import QRCode from "qrcode";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function parseQrLoginValue(value) {
  const raw = String(value || "").trim();
  if (!raw) return null;

  const parseFromSearchParams = (searchParams) => {
    const qrId = searchParams?.get?.("qr_id");
    const code = searchParams?.get?.("code");
    if (qrId && code) return { qr_id: String(qrId), code: String(code) };
    return null;
  };

  try {
    const base = typeof window !== "undefined" ? window.location.origin : "http://localhost";
    const url = new URL(raw, base);
    const found = parseFromSearchParams(url.searchParams);
    if (found) return found;
  } catch {}

  const lowered = raw.toLowerCase();
  const withoutPrefix = lowered.startsWith("qr_login:") ? raw.slice("qr_login:".length).trim() : raw;
  const queryCandidate = withoutPrefix.startsWith("?") ? withoutPrefix.slice(1) : withoutPrefix;
  if (queryCandidate.includes("qr_id=") || queryCandidate.includes("code=")) {
    try {
      const sp = new URLSearchParams(queryCandidate);
      const found = parseFromSearchParams(sp);
      if (found) return found;
    } catch {}
  }

  const parts = withoutPrefix.split(/[|:]/).map((p) => String(p || "").trim()).filter(Boolean);
  if (parts.length >= 2) {
    return { qr_id: parts[0], code: parts[1] };
  }

  try {
    const obj = JSON.parse(withoutPrefix);
    const qrId = obj?.qr_id;
    const code = obj?.code;
    if (typeof qrId === "string" && qrId.trim() && typeof code === "string" && code.trim()) {
      return { qr_id: qrId.trim(), code: code.trim() };
    }
  } catch {}

  return null;
}

export async function toQrDataUrl(value, options = {}) {
  const text = typeof value === "string" ? value : String(value ?? "");
  if (!text) return null;
  const width = Number.isFinite(options?.width) ? options.width : 240;
  const margin = Number.isFinite(options?.margin) ? options.margin : 2;
  const color = options?.color || { dark: "#ffffff", light: "#00000000" };
  const extra = options && typeof options === "object" ? { ...options } : {};
  delete extra.width;
  delete extra.margin;
  delete extra.color;
  try {
    return await QRCode.toDataURL(text, { width, margin, color, ...extra });
  } catch {
    return null;
  }
}

export function getPublicBasePath() {
  const raw = typeof process !== "undefined" ? process.env.PUBLIC_URL : "";
  const v = typeof raw === "string" ? raw.trim() : "";
  if (!v || v === "/") return "";
  return v.endsWith("/") ? v.slice(0, -1) : v;
}

export function buildAppUrl(pathWithQuery = "/") {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const base = getPublicBasePath();
  const raw = typeof pathWithQuery === "string" ? pathWithQuery : String(pathWithQuery ?? "");
  const p = raw.startsWith("/") ? raw : `/${raw}`;
  return `${origin}${base}${p}`;
}

export function validatePassword(password) {
  const p = String(password || "");
  if (p.length < 8) return "Пароль должен быть минимум 8 символов";
  if (!/[A-Z]/.test(p)) return "Пароль должен содержать минимум 1 заглавную английскую букву (A-Z)";
  if (!/[a-z]/.test(p)) return "Пароль должен содержать минимум 1 строчную английскую букву (a-z)";
  if (!/\d/.test(p)) return "Пароль должен содержать минимум 1 цифру (0-9)";
  if (!/[^A-Za-z0-9]/.test(p)) return "Пароль должен содержать минимум 1 спецсимвол (например: !@#$%)";
  return null;
}
